import React from 'react';
import PropTypes from 'prop-types';

import LinksColumn from './LinksColumn';

const Links = ({ links }) => (
  <div className="ft-links">
    {links.map((columnData, idx) => (
      <LinksColumn
        columnData={columnData}
        key={idx} // eslint-disable-line react/no-array-index-key
      />
    ))}
  </div>
);

Links.propTypes = {
  links: PropTypes.arrayOf(PropTypes.object),
};

export default Links;
